<div class="overlay-warp">
    <div class="item">
        <p (click)="changeName()" translate>steps.menu.changeName</p>
    </div>
    <div class="item">
        <p (click)="duplicate()" translate>steps.menu.duplicated</p>
    </div>
    <div class="item">
        <p (click)="delete()" translate>steps.menu.delete</p>
    </div>
    <div *ngIf="index!=0 || index+1!=(numOfStep$ | async)" class="divider"></div>
    <div class="item">
        <p *ngIf="index+1!=(numOfStep$ | async)" (click)="move('b')" translate>steps.menu.moveBottom</p>
    </div>
    <!-- //left == bottom = move to next , right == top = move to previous -->
    <div class="item">
        <p *ngIf="index!=0" (click)="move('t')" translate>steps.menu.moveTop</p>
    </div>
</div>